export const trackingEvents = {
  SAVE_BUTTON: {
    CLICKED: 'employer_fulfilment.save_button.clicked',
  },
}
